import useContactUsContent from './useContactUsContent';

export default useContactUsContent;
